/* eslint-disable no-undef */
import asyncScriptLoader from '../asyncScriptLoader'

const googleAnalyticsID = process.env.GOOGLE_ANALYTICS_ID

const src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsID}`

asyncScriptLoader(src)

window.gtag('config', googleAnalyticsID, {
  send_page_view: false
})
